export enum FeatureFlag {
  IsNewPrequalificationEnabled = 'isNewPrequalificationEnabled',
}
